var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0A0A0A",
  fillRule: "evenodd",
  d: "M5 7H0V5h5V0h2v5h5v2H7v5H5z",
  clipRule: "evenodd"
})));
export { SvgAddDark as ReactComponent };
export default __webpack_public_path__ + "static/media/addDark.eb16ff92.svg";